import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getAssesmentList = async () => {
  const response = await axios.get(`${base_url}assesmentreport`, config);  

  return response.data;
};

//new endpoint 

const getAssesmentOverviewList = async ()=>{
  const response = await axios.get(`${base_url}assesmentreport/overview`, config);
  return response.data;

}

const assesmentService = {
  getAssesmentList,
  getAssesmentOverviewList,
};

export default assesmentService;
